import { FC } from "react"
import { Grid, Typography } from "@mui/material"
import { useParams } from "react-router-dom"
import {
  HasSidebarLayout,
  DataLoad,
  CollapsibleSection,
  EntityHeader,
  DataLoggerInfo,
  DataLoggerChartTabs,
  DataLoggerEvents,
  DataLoggerLastReadings,
  DataLoggerIntervals,
  DataLoggerReadingUploads,
  DownloadMeasurementsModal,
} from "src/components"
import { useDataLoggerRequest } from "src/hooks/api"
import { DataLogger } from "src/api"

interface DataLoggerShowContentProps {
  dataLogger: DataLogger | undefined;
  refetchDataLogger?: () => void;
}

const DataLoggerShowContent: FC<DataLoggerShowContentProps> = ({ dataLogger, refetchDataLogger }) => {
  if (!dataLogger) return null

  const title = `DataPUCK: ${dataLogger.deviceId}`

  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <EntityHeader title={title}>
            <Grid container spacing={2}>
              <Grid item>
                <DownloadMeasurementsModal deviceType="dataLogger" deviceId={dataLogger.deviceId} />
              </Grid>
            </Grid>
          </EntityHeader>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h6" sx={{ mb: 1 }}>
            DataPUCK Information
          </Typography>
          <DataLoggerInfo dataLogger={dataLogger} refetchDataLogger={refetchDataLogger} />
        </Grid>
        <Grid item xs={12}>
          <CollapsibleSection title="DataPUCK Chart Of Readings">
            <DataLoggerChartTabs dataLogger={dataLogger} />
          </CollapsibleSection>
        </Grid>
        <Grid item xs={12}>
          <CollapsibleSection title="Events">
            <DataLoggerEvents dataLoggerId={dataLogger.id} />
          </CollapsibleSection>
        </Grid>
        <Grid item xs={12}>
          <CollapsibleSection title="DataPUCK Last Readings">
            <DataLoggerLastReadings dataLogger={dataLogger} />
          </CollapsibleSection>
        </Grid>
        <Grid item xs={12}>
          <CollapsibleSection title="DataPUCK Interval History">
            <DataLoggerIntervals dataLogger={dataLogger} />
          </CollapsibleSection>
        </Grid>
        <Grid item xs={12}>
          <CollapsibleSection title="DataPUCK Readings Uploads">
            <DataLoggerReadingUploads dataLogger={dataLogger} />
          </CollapsibleSection>
        </Grid>
      </Grid>
    </>
  )
}

const DataLoggerShow: FC = () => {
  const params = useParams()
  const { deviceId } = params as { deviceId: string }
  const { data, isInitialLoading, isError, error, refetch } = useDataLoggerRequest({ deviceId })
  document.title = `CLīMIT Admin Panel - DataPUCK ${data?.deviceId || ''}`

  return (
    <HasSidebarLayout>
      <DataLoad
        isLoading={isInitialLoading}
        isError={isError}
        errorMessage={error?.message}
      >
        <DataLoggerShowContent dataLogger={data} refetchDataLogger={refetch} />
      </DataLoad>
    </HasSidebarLayout>
  )
}

export default DataLoggerShow
